import { CommentsAndDocumentsClient } from "../../../../../Wrap/Api/Instruction/CommentsAndDocuments";
import { DemandType } from "../../../../../Wrap/Models/Domains/Workflow/DemandType";

export interface ICommentsAndDocumentsQuery {
    caseDataId: number;
    demandType: DemandType;
    caseGroupSequenceNumber: number;
    sequenceNumber: number;
}

export class CommentsAndDocumentsAction {
    public static loadCommentsAndDocuments(
        query: ICommentsAndDocumentsQuery,
        currentPage,
        count,
        callBack?: (val: any) => void
    ): void {
        const client = new CommentsAndDocumentsClient();
        const promise = client.get(
            query.caseDataId,
            query.demandType,
            query.caseGroupSequenceNumber,
            query.sequenceNumber,
            (currentPage - 1 ) * count + 1,
            count
        );
        promise.onSuccess((res) => {
            callBack(res);
        });
    }
}
